import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.tab != this.props.tab) {
            return true;
        }

        if (nextProps.profiles != this.props.profiles) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        return false;
    }

    render({ logged_in, submitting, profiles }) {
        if (logged_in && !submitting) {
            if (profiles && profiles.length > 1) {
                return (
                    <profiles-nav>
                        <a
                            href='#you'
                            className={this.props.tab == 'you'  || !this.props.tab ? 'active' : ''}
                            onClick={this.setWho}
                        >
                            Your Profile
                        </a>
                        <a
                            href='#friend'
                            className={this.props.tab == 'friend' ? 'active' : ''}
                            onClick={this.setWho}
                        >
                            Friend Profiles
                        </a>
                        <a
                            href='#new'
                            className={this.props.tab == 'new' ? 'active' : ''}
                            onClick={this.setWho}
                        >
                            New Profile
                        </a>
                    </profiles-nav>
                );
            }

            return (
                <profiles-nav>
                    <a
                        href='#you'
                        className={this.props.tab == 'you' || !this.props.tab  ? 'active' : ''}
                        onClick={this.setWho}
                    >
                        Your Profile
                    </a>
                    <a
                        href='#new'
                        className={this.props.tab == 'new' ? 'active' : ''}
                        onClick={this.setWho}
                    >
                        New Profile
                    </a>
                    <a className='disabled' href='#'>
                        0 Friend Profiles
                    </a>
                </profiles-nav>
            );
        }

        return (<profiles-nav />);
    }

    setWho = (e) => {
        e.preventDefault();
        const hash = e.target.hash.replace('#', '');
        let profile = null;

        if (hash == 'you') {
            profile = this.props.profiles[0];
        }

        this.props.userUpdate({
            tab: hash,
            selected_profile: profile,
        });

        this.props.setSuccess(false);
    }
}

const mapStateToProps = (state) => ({
    profiles: state.user && state.user.profiles,
    tab: state.user && state.user.tab,
    logged_in: state.user && state.user.logged_in,
    submitting: state.product && state.product.submitting,
});

const mapDispatchToProps = (dispatch) => ({
    setSuccess: (payload) => dispatch({ type: 'form:update', payload: { success: payload } }),
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
